<template>
  <div v-if="showWarning"
       class="alert alert-danger alert-dismissible fade show Autologout_Div">
    <p>You’ve been inactive for a while. For your security, you’ll be signed out in {{ tokenTimeRemaining }} seconds</p>
    <button type="button" class="btn-close" aria-label="Close" @click="dismissed = true"></button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tokenTimeRemaining: 0,
      mouseMoveHandler: null,
      countdownInterval: null,
      dismissed: false,
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
    tokenExpirationTime() {
      return this.$store.state.tokenExpirationTime;
    },
    showWarning() {
      return !this.dismissed &&
             this.isLoggedIn &&
             this.tokenTimeRemaining > 0 &&
             this.tokenTimeRemaining <= 20;
    }
  },
  created() {
    if (this.isLoggedIn) {
      this.startCountdown();
      this.startMonitoring();
    }
    this.$store.dispatch('retriveUserDetails', this.$router);
  },
  beforeUnmount() {
    window.removeEventListener("mousemove", this.mouseMoveHandler);
    window.removeEventListener("keydown", this.mouseMoveHandler);
    window.removeEventListener("click", this.mouseMoveHandler);
    clearInterval(this.countdownInterval);
  },
  watch: {
    tokenExpirationTime(newValue) {
      console.log("Token expiration updated, restarting countdown.");
      this.dismissed = false;
      this.startCountdown();
    },
    isLoggedIn(newVal) {
      if (!newVal) {
        clearInterval(this.countdownInterval);
        window.removeEventListener("mousemove", this.mouseMoveHandler);
        window.removeEventListener("keydown", this.mouseMoveHandler);
        window.removeEventListener("click", this.mouseMoveHandler);
      }
    }
  },
  methods: {
    closeAllModals() {
      document.querySelectorAll('.modal.show').forEach((modalElement) => {
        const modal = bootstrap.Modal.getInstance(modalElement);

        if (modal) {
          modal.hide();
        }
      });

      // Remove any leftover Bootstrap backdrop
      document.querySelectorAll('.modal-backdrop').forEach((backdrop) => {
        backdrop.remove();
      });

      // Restore body state
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('padding-right');
    },
    startCountdown() {
      if (this.countdownInterval) clearInterval(this.countdownInterval);

      this.countdownInterval = setInterval(() => {
        const currentTime = Math.floor(Date.now() / 1000);
        this.tokenTimeRemaining = this.tokenExpirationTime - currentTime;

        if (this.tokenTimeRemaining <= 0) {
          clearInterval(this.countdownInterval);
          this.closeAllModals();
          this.$store.dispatch('retriveUserDetails', this.$router);
          localStorage.removeItem('jwt');
          this.$router.push('/');
        }
      }, 1000);
    },
    startMonitoring() {
      this.mouseMoveHandler = this.debounce(() => {
        if (this.tokenTimeRemaining > 0 && this.tokenTimeRemaining < 20) {
          this.$store.dispatch('retriveUserDetails', this.$router);
        }
      }, 1000);

      window.addEventListener("mousemove", this.mouseMoveHandler);
      window.addEventListener("keydown", this.mouseMoveHandler);
      window.addEventListener("click", this.mouseMoveHandler);
    },
    debounce(fn, delay) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), delay);
      };
    }
  }
};
</script>